import { withAuthenticationRequired } from "@auth0/auth0-react";
import Austria_LayerMenuComponent from '../components/Austria_LayerMenu';
import React from "react";

export const Austria_ProtectedRoute = ({ component }) => {
  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => (
      <div className="pos-center">
        <div className="loader"></div>
      </div>
    ),
  });

  return(
    <div>
      <Component />
      <Austria_LayerMenuComponent />
    </div>
  )
};